import { ColumnsType } from "antd/es/table";
import { Space, Dropdown, Tooltip, Tag } from "antd";
import { BotoesAcoes } from "../../ViewGerenciarPostagens/styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";
import { getMenuItems } from "../constants/itemsActionColumns";
import ColumnSearch from "../../../components/ColumnSearch";

export const Columns = (
  onClick: (e: any) => void,
  setAnuncioId: (e: number) => void,
  setActive: (e: string) => void,
  filteredInfo: {
    proprietario?: string[] | null;
     celular?: string[] | null;
    empreendimento?: string[] | null;
    dataAnuncio?: string[] | null;
    dataInativacaoAnuncio?: string[] | null;
    active?: string[] | null;
  }
): ColumnsType<any> => {
  const items = getMenuItems();

  return [
    {
      title: "Proprietário",
      dataIndex: "proprietario",
      key: "proprietario",
      width: "30%",
      render: (_, row) => (
        <Tooltip title={row.descricao}>
          <Tag>{row.proprietario}</Tag>
        </Tooltip>
      ),
      filteredValue: filteredInfo.proprietario || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.proprietario.includes(value),
      ...ColumnSearch<any>({ dataIndex: "proprietario" }),
    },
    {
  title: "Celular",
  dataIndex: "celular",
  key: "celular",
  width: "15%",
  filteredValue: filteredInfo.celular || null, // ✅ mantém o filtro
  onFilter: (value, record) =>
    String(record.celular ?? "").includes(String(value)), // ✅ filtra de verdade
  render: (value: string) => value ?? "N/A",
  ...ColumnSearch<any>({ dataIndex: "celular" }),
},
    {
      title: "Empreendimento",
      dataIndex: "empreendimento",
      key: "empreendimento",
      width: "30%",
      filteredValue: filteredInfo.empreendimento || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.empreendimento.includes(value),
      ...ColumnSearch<any>({ dataIndex: "empreendimento" }),
    },
    {
      title: "Data Anúncio",
      dataIndex: "dataAnuncio",
      key: "dataAnuncio",
      width: "30%",

      filteredValue: filteredInfo.dataAnuncio || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.dataAnuncio.includes(value),
      ...ColumnSearch<any>({ dataIndex: "dataAnuncio" }),
    },
    {
      title: "Data Inativação",
      dataIndex: "dataInativacaoAnuncio",
      key: "dataInativacaoAnuncio",
      width: "30%",

      filteredValue: filteredInfo.dataInativacaoAnuncio || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.dataInativacaoAnuncio.includes(value),
      ...ColumnSearch<any>({ dataIndex: "dataInativacaoAnuncio" }),
    },
    {
      title: "Ativo",
      dataIndex: "active",
      key: "active",
      width: "30%",
      filters: [
        { text: "Sim", value: "Sim" },
        { text: "Não", value: "Não" },
      ],
      filteredValue: filteredInfo.active || null,
      onFilter: (value, record) => record.active.includes(value),
      filterSearch: true,
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",
      filteredValue: null,
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                setAnuncioId(row.id);
                setActive(row.active);
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
